// Community 게시글 주제 - 확인완료 idx
// 확인완료는 게시글 주제 선택 시 나오면 안 됨
export const COMMUNITY_CHANGE_CHECK_IDX = 9;
export const COMMUNITY_FIND_IDX = 2;
export const COMMUNITY_FINDING_IDX = 3;
